import FormatError from '../system/FormatError';
export default class BooleanUtils {
    static toNumber(value) {
        return value ? 1 : 0;
    }
    static toNumberString(value) {
        return BooleanUtils.toNumber(value).toString();
    }
    static fromNumber(value) {
        if (value === 0) {
            return false;
        }
        else {
            return true;
        }
    }
    static isBoolean(obj) {
        return typeof (obj) === 'boolean' || obj instanceof Boolean;
    }
    static parse(value) {
        const result = this.tryParse(value);
        if (result === undefined) {
            throw new FormatError(`'${value}' does not represent a number in a valid format.`);
        }
        return result;
    }
    static tryParse(value, valueOnFailure = undefined) {
        if (value === undefined) {
            return valueOnFailure;
        }
        else if (value.toLowerCase() === 'true') {
            return true;
        }
        else if (value.toLowerCase() === 'false') {
            return false;
        }
        else {
            return valueOnFailure;
        }
    }
}
//# sourceMappingURL=BooleanUtils.js.map